export default __webpack_public_path__ + "static/media/unpin.d7600e23.svg";